import { toast, Slide } from "react-toastify";
let lastToastId = null;
const toastError = (message) => {
  if (lastToastId) {
    toast.dismiss(lastToastId);
  } 
    lastToastId = toast.error(
      message
        ? message
        : message === 500
        ? "Something went wrong, Please try again !"
        : "Something went wrong, Please try again !",
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      }
    );
};

export const toastSuccess = (message) => {
  if (lastToastId) {
    toast.dismiss(lastToastId);
  } 
    lastToastId = toast.info(
      message
        ? message
        : message === 500
        ? "Something went wrong, Please try again !"
        : "Something went wrong, Please try again !",
      {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Slide,
      }
    );
};

export default toastError;
